import { useTranslation } from "next-i18next";
import "react-multi-carousel/lib/styles.css";
import "../../../styles/scss/solutions.module.scss";
import "../../../styles/scss/_trusted-companies.module.scss";

const TrustedCompanyTopHeading = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <section className={"mw-trust-company solution-page-trusted"}>
        <div className={"container"}>
          <p>{t('solutions.common.trustedHeading')}</p>
          <div className={"d-flex"}>
            <div className={"right-block"}>
              <div className={"logo-slider slider-trusted"}>
                <div>
                  <img
                      src={"/images/trusted-company/bardeen.svg"}
                      alt={"Bardeen"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/generation-esports.svg"}
                      alt={"Generation ESPORTS"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/hotplate.svg"}
                      alt={"Hotplate"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/bujeti.svg"}
                      alt={"Bujeti"}
                      className={"rm"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/activeloop.svg"}
                      alt={"Activeloop"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/markovML.svg"}
                      alt={"MarkovML"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/invopop.svg"}
                      alt={"Invopop"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/revenium.svg"}
                      alt={"Revenium"}
                      className={"rm"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/brainboard.svg"}
                      alt={"Brainboard"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/finflex.svg"}
                      alt={"Finflex"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/cloudchipr.svg"}
                      alt={"Cloudchipr"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/mindorigin.svg"}
                      alt={"Mindorigin"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/monetizenow.svg"}
                      alt={"Monetizenow"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/cleardemand.svg"}
                      alt={"Clear Demand"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/trademarkia.svg"}
                      alt={"Trademarkia"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/kapstan.svg"}
                      alt={"Kapstan"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/mashvisor.svg"}
                      alt={"Mashvisor"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/jetscom.svg"}
                      alt={"Jetscom"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/aceturtle.svg"}
                      alt={"Aceturtle"}
                      width={200}
                      height={200}
                  />
                </div>

                <div>
                  <img
                      src={"/images/trusted-company/bardeen.svg"}
                      alt={"Bardeen"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/generation-esports.svg"}
                      alt={"Generation ESPORTS"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/hotplate.svg"}
                      alt={"Hotplate"}
                      width={200}
                      height={200}
                  />
                  <img
                      src={"/images/trusted-company/bujeti.svg"}
                      alt={"Bujeti"}
                      className={"rm"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/activeloop.svg"}
                      alt={"Activeloop"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/markovML.svg"}
                      alt={"MarkovML"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/invopop.svg"}
                      alt={"Invopop"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/revenium.svg"}
                      alt={"Revenium"}
                      className={"rm"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/brainboard.svg"}
                      alt={"Brainboard"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/finflex.svg"}
                      alt={"Finflex"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/cloudchipr.svg"}
                      alt={"Cloudchipr"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/mindorigin.svg"}
                      alt={"Mindorigin"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/monetizenow.svg"}
                      alt={"Monetizenow"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/cleardemand.svg"}
                      alt={"Clear Demand"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/trademarkia.svg"}
                      alt={"Trademarkia"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/kapstan.svg"}
                      alt={"Kapstan"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/mashvisor.svg"}
                      alt={"Mashvisor"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/jetscom.svg"}
                      alt={"Jetscom"}
                      width={200}
                      height={200}
                  />

                  <img
                      src={"/images/trusted-company/aceturtle.svg"}
                      alt={"Aceturtle"}
                      width={200}
                      height={200}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default TrustedCompanyTopHeading;
